
import { defineComponent, PropType, ref, watch, nextTick } from 'vue'
import { renderQrCode } from '@/utils/qrcode'
import { getStarUnlockQrUrl } from '@/utils/useStarTip'

export default defineComponent({
  name: 'StarTipDialog',
  props: {
    tipDialog: { type: Object as PropType<any>, required: true },
    showQrDialog: { type: Boolean, required: true },
    qrUrl: { type: String, default: () => getStarUnlockQrUrl() }
  },
  emits: ['update:showQrDialog'],
  setup(props) {
    const qrContainerRef = ref<HTMLElement | null>(null)
    watch(() => props.showQrDialog, async (val) => {
      if (val) {
        await nextTick()
        if (qrContainerRef.value) renderQrCode(qrContainerRef.value, props.qrUrl)
      }
    })
    return { qrContainerRef }
  }
})
